import { createNavigationStmtInstruction } from './CreateNavigationStmt';
import { removeNavigationStmtInstruction } from './RemoveNavigationStmt';
import { sortNavigationStmtInstruction } from './SortNavigationStmt';
export const navigationInstruction = `
## Navigation
Navigation is important part of any application. It allows users to move between different views and pages. Define navigation items for the best user experience possible.

### Navigation commands

${createNavigationStmtInstruction}
${removeNavigationStmtInstruction}
${sortNavigationStmtInstruction}
`;
//# sourceMappingURL=navigationInstruction.js.map